import React from 'react';
import './index.css';


export default class HeaderTargetPair extends React.Component{
    
    render(){

        var result = (
        <div className='header-target-pair'>
                
            <div className='header-key'>
                <p className='header-key-p'>{this.props.headerKey}:</p>
            </div>

            <div className='target-value'>
                <input className='target-value-input' type="text" placeholder={this.props.headerKey} onChange={this.props.onValChange}></input>
            </div>

        </div>)

        if (this.props.special == "true"){
            result =(
                <div className='header-target-pair'>
                        
                    <div className='header-key'>
                        <p className='header-key-p'>{this.props.headerKey}:</p>
                    </div>
        
                    <div className='target-value'>
                        <select className='target-value-input'>
                            {this.props.options}
                        </select>
                    </div>
        
                </div>)
        }
        
        return result
    }
}